import pipe from 'ramda/src/pipe'
import pathEq from 'ramda/src/pathEq'
import userIdSelector from 'root/src/client/logic/auth/selectors/userIdSelector'
import { apiStoreLenses } from 'root/src/client/logic/api/lenses'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'

const { viewDropEventChild } = apiStoreLenses

export default (state) => {
	const recordId = currentRouteParamsRecordId(state)
	const brandId = userIdSelector(state)
	if (!brandId) return false
	return pipe(
		viewDropEventChild(recordId),
		pathEq(['brand', 'id'], brandId),
	)(state)
}
